import { combineReducers } from 'redux';
import currentUser from "./user/currentUserReducer";
import bills from "./admin/bills/billsReducer";
import marketplaces from "./marketplace/marketplacesReducer";
import marketplace from "./marketplace/marketplaceReducer";
import item from "./item/itemReducer";
import serviceAreas from "./serviceAreas/serviceAreasReducer";
import deliveryOrderBatches from "./deliveryOrderBatches/deliveryOrderBatchesReducer";

export default combineReducers({
  currentUser,
  marketplaces,
  marketplace,
  bills,
  serviceAreas,
  item,
  deliveryOrderBatches,
});
